<div class="modal-header">
    <div class="modal-title text-center" style="width: 100%;" id="modal-title">
        <h5 class="mb-0">Cargar Certificado Reglamento UE 2018/848</h5>
    </div>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    [disabled]="uploading"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
    <div>
        <div *ngIf="fileCertificate">
            <div class="d-flex justify-content-center" style="max-height: 60px; border: 1px solid rgb(199, 199, 199); border-radius: 5px; padding: 5px; margin-bottom: 5px; overflow: hidden; text-overflow: ellipsis;">
                <p style="text-overflow: ellipsis; width: 90%; height: auto;">{{fileCertificate.name}}</p>
                <button class="btn" (click)="removeUploadingFile(fileInput)"><i class="fas fa-times"></i></button>
            </div>
        </div>

        <div class="custom-file">
            <input 
                #fileInput 
                type="file" 
                name="certificate_ue" 
                accept="application/pdf" 
                max="1" 
                class="custom-file-input" 
                (change)="loadCertificateFile($event)" 
                [class.is-invalid]="submitted && !fileCertificate"
            >

            <label class="custom-file-label" for="certificate_ue">Seleccione el certificado a cargar</label>
            
            <div *ngIf="submitted && !fileCertificate" class="invalid-feedback">
                Certificado a subir requerido
            </div>
        </div>
    </div>

    <div class="mt-4">
        <label for="certificate_comments">Comentarios:</label>
        <textarea
            style="width: 100%" 
            class="form-control"
            name="certificate_comments"
            id="certificate_comments"
            [(ngModel)]="certificate_comments"
            cols="3"
        ></textarea>
    </div>

    <div *ngIf="uploading" style="width: 100vw; height: 100vh; background-color: #00000055; position: fixed; top: 0; left: 0; z-index: 99999;">
        <div  style="position: fixed; right: 20px; bottom: 20px; background-color: #FFFFFF; padding: 10px; border-radius: 5px;">
            <span class="text-dark" style="margin-right: 10px;">Subiendo Certificado</span>
            <span class="spinner-border spinner-border-sm align-center text-success" ></span>
        </div>
    </div>
</div>

<div class="modal-footer justify-content-center">
  <button
    type="button"
    class="btn btn-outline-secondary"
    [disabled]="uploading"
    (click)="modal.close('cancel click')"
  >
    Cerrar
  </button>
  <button
    type="button"
    class="btn btn-success"
    [disabled]="uploading"
    (click)="uploadCertificate()"
  >
    <span
      *ngIf="uploading"
      class="spinner-border spinner-border-sm mr-1"
    ></span>
    Subir
  </button>
</div>